export const areAllFacetsChecked = (facets, facetSelection) => {
  let allFacetsAreChecked = false;

  for (let idx = 0; idx < facets.length; idx++) {
    for (let itemidx = 0; itemidx < facets[idx].items.length; itemidx++) {
      const facetGroup = facets[idx];
      const facetItem = facetGroup.items[itemidx];
      if (
        !facetSelection[facetGroup.id] ||
        !facetSelection[facetGroup.id][facetItem.key] ||
        (facetGroup.value && (facetGroup.value[0] !== facetGroup.min || facetGroup.value[1] !== facetGroup.max))
      ) {
        allFacetsAreChecked = true;
      }
    }
    if (allFacetsAreChecked) break;
  }
  return allFacetsAreChecked;
};

export const areAllFacetsUnchecked = (facets, facetSelection) => {
  let allFacetsAreUnchecked = true;

  for (let idx = 0; idx < facets.length; idx++) {
    for (let itemidx = 0; itemidx < facets[idx].items.length; itemidx++) {
      const facetGroup = facets[idx];
      const facetItem = facetGroup.items[itemidx];
      if (facetSelection[facetGroup.id] && facetSelection[facetGroup.id][facetItem.key]) {
        allFacetsAreUnchecked = false;
      }
    }
    if (!allFacetsAreUnchecked) break;
  }
  return allFacetsAreUnchecked;
};

export const getQueryParams = (name, queryString = '') => {
  return {
    es_query: queryString,
    pageName: name,
    include: {},
    exclude: {},
    offset: 0,
    limit: 50
  };
};

export const getCMSQueryParams = (name, queryString = '') => {
  return {
    es_query: queryString,
    pageName: name,
    filter: {
      where: {
        and: []
      },
      fullTextSearch: '',
      fullTextTerms: []
    },
    offset: 0,
    limit: 50,
  };
};
